<template>
  <div class="RawLeads">
    <div class="RawLeads__buttons-wrapper">
      <BulkFileUpload/>
    </div>
    <template>
      <v-container>
        <RawLeadTable :leads="rawLeads" />
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import RawLeadTable from "@/components/table/RawLeadTable";
import BulkFileUpload from "@/components/forms/BulkFileUpload";

export default {
  name: "RawLeads",
  components: {
    RawLeadTable,
    BulkFileUpload,
  },
  methods: {
    ...mapActions({
      loadRawLeads: "rawLeads/loadRawLeads",
    }),
  },
  created() {
    this.sockets.subscribe("RAW_LEAD_ADD", console.log);
  },
  mounted() {
    this.loadRawLeads();
  },
  computed: {
    ...mapGetters({
      rawLeads: "rawLeads/rawLeads",
      loadingRawLeads: "rawLeads/loadingRawLeads",
      user: "auth/user",
    }),
  },
};
</script>

<style lang="scss">
.RawLeads {
  padding: 50px;
  width: 100%;
  height: 100%;
  &__buttons-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 50px;
  }
  &__buttons {
    button {
      margin-right: 30px;
    }
  }
}

.btn-wrapper {
  width: 100%;
  margin-bottom: 20px;
  text-align: right;
}

.button-cover {
  background-color: #fff;
  box-shadow: 0 10px 20px -8px #c5d6d6;
  border-radius: 4px;
  padding: 15px 25px;
  width: 100%;
}

.button {
  position: relative;
  width: 74px;
  height: 36px;
  margin: 0 0 0 auto;
  overflow: hidden;
}

.button.r,
.button.r .layer {
  border-radius: 100px;
}

.button.b2 {
  border-radius: 2px;
}
</style>